@use "../../../../../globals/bcp";

.f-mini-impersonate-flyout__feature-bar {
  .flyout-top-button-content {
    padding: 0.5rem 1rem;
  }
}

// ------------------- CUSTOM -----------------------------------------------------------------------------------------
// ...
